import { usePage } from '@inertiajs/inertia-vue3'
import { computed } from 'vue'

export function useAuth() {
  const { props } = usePage()

  /*
   * Primary Auth Entities
   */
  const authCompanyUser = computed(() => props.value.auth?.company_user)
  const authCompanyTeamMember = computed(() => props.value.auth?.company_team_member)
  const authCompanyTeamMembers = computed(() => props.value.auth?.company_team_members)
  const authCompany = computed(() => props.value.auth?.company)
  const authAccount = computed(() => props.value.auth?.account)
  const isCompanyUser = computed(() => !!authCompanyUser.value)

  /*
   * Additional attributes required for display in layout sidebar or header
   */
  const integrationRequiringAuthorization = computed(
    () => props.value.auth?.integration_requiring_authorization ?? false
  )

  const integrationExpiringSoon = computed(
    () => props.value.auth?.integration_expiring_soon ?? false
  )

  const needsHomeBase = computed(() => props.value.auth?.needs_home_base)

  const portalAppConfigRequiringAction = computed(
    () => props.value.auth?.portal_app_config_requiring_action ?? false
  )

  const accountNeedsBillingTaxDetails = computed(
    () => props.value.auth?.account_needs_billing_tax_details
  )

  const ordersRequiringActionCount = computed(() => props.value.ordersRequiringActionCount)

  const otherTeamMemberNeedsHomeBase = computed(
    () => props.value.auth?.other_team_member_needs_home_base
  )

  return {
    authCompanyUser,
    authCompanyTeamMember,
    authCompanyTeamMembers,
    authCompany,
    authAccount,
    isCompanyUser,
    integrationRequiringAuthorization,
    integrationExpiringSoon,
    needsHomeBase,
    portalAppConfigRequiringAction,
    ordersRequiringActionCount,
    otherTeamMemberNeedsHomeBase,
    accountNeedsBillingTaxDetails
  }
}
